<template>
    <div class="product-barcodes-input">
        <ErrorsZone class="col-6" v-if="validationErrors" :errors="lValidationErrors"></ErrorsZone>
        <div class="barcodes-list mb-2">
            <ul v-if="barcodes.length" class="list-group">
                <li v-for="barcode in barcodes" :key="barcode" class="list-group-item barcode">
                    <button type="button" class="btn btn-danger float-right" @click="removeBarcode(barcode)">
                        <i class="fad fa-times"></i> Retirer
                    </button>
                    {{ barcode }}
                    <input type="hidden" :name="name + '[]'" :value="barcode">
                </li>
            </ul>
            <div v-else class="alert alert-info">
                <i class="fad fa-info-circle"></i> Aucun code-barres
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <div class="input-group">
                        <input class="form-control" type="text" maxlength="13" id="typedBarcode" v-model.trim="typedBarcode" @keydown.enter.prevent="addTypedBarcode">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" @click="addTypedBarcode">
                                <i class="fad fa-plus"></i> Ajouter
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <button type="button" class="btn btn-secondary" :disabled="loading" @click="generateBarcode">
                    <i class="fad fa-calculator"></i> Ajouter un code disponible
                </button>
            </div>
        </div>
        <ErrorsZone :errors="postErrors"></ErrorsZone>
        <ErrorsZone class="col-6" v-if="dynamicValidationError" :errors="dynamicValidationError"></ErrorsZone>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";

    import {usePostRequest} from "../compositions/axios/postRequest";

    export default {
        name: "ProductBarcodesInput",

        components: {
            ErrorsZone,
        },

        props: {
            name: {
                type: String,
                required: true,
            },
            value: {
                type: Array,
                required: false,
                default: [],
            },
            validationErrors: {
                type: Object,
                required: false,
                default: null,
            },
        },

        setup() {
            const {
                loading,
                errors: postErrors,
                post,
            } = usePostRequest();

            return {
                loading,
                postErrors,
                post,
            };
        },

        data() {
            return {
                typedBarcode: '',
                dynamicValidationError: null,
                lValidationErrors: this.validationErrors,
                barcodes: this.value || [],
            };
        },

        methods: {
            async generateBarcode() {
                const response = await this.post('/espace-admin/produits/code-barre-disponible', {
                    barcodes: this.barcodes,
                });
                if (response && response.barcode) {
                    this.addBarcode(response.barcode);
                }
            },

            addTypedBarcode() {
                this.dynamicValidationError = null;

                if (!this.typedBarcode.match(/^[0-9]{13}$/)) {
                    this.dynamicValidationError = {message: "Le code-barres doit contenir 13 chiffres."};
                    return;
                }

                if (this.barcodes.indexOf(this.typedBarcode) > -1) {
                    this.dynamicValidationError = {message: "Ce code-barres est déjà rattaché au produit."};
                    return;
                }

                this.addBarcode(this.typedBarcode);
                this.typedBarcode = '';
            },

            addBarcode(barcode) {
                this.barcodes.push(barcode);
            },

            removeBarcode(barcode) {
                this.barcodes = this.barcodes.filter((c) => c !== barcode);
            },
        },
    }
</script>
